import { Injectable } from '@angular/core'; 
import { CanDeactivate } from '@angular/router'; 
import { Observable } from 'rxjs';
import { GradingComponent } from './grading/grading/grading.component';

@Injectable() 
export class CanLeaveGradingGuard implements CanDeactivate<GradingComponent> {
  async canDeactivate(target: GradingComponent): Promise<boolean> { 
    if (await target.hasChanges()) { 
      return window.confirm('You are about to leave your grading form.  If you have saved your progress or are submitting your last grading sheet, click "OK" to proceed.  Otherwise, any unsaved changes will be lost.');
    } 
    return true; 
  }
}



// WEBPACK FOOTER //
// ./src/app/home/leave-grading-guard.service.ts